import React, {Component} from 'react';
import {
    Button,
    Table,
    List,
    Header,
    Label,
    Icon,
    Image
} from 'semantic-ui-react';
import {FormattedNumber} from 'react-intl';
import { withRouter } from 'react-router-dom';
import update from 'react-addons-update';

import SaleData from "../../data/SaleData";
import NoData from "../../components/extras/NoData";
import MainToolbar from "../../components/extras/MainToolbar";
import LoadingRow from "../../components/extras/LoadingRow";
import localDB from "../../data/localDB";
import {showToast} from "../../actions/ToastAction";
import connect from "react-redux/es/connect/connect";


class CounterSale extends Component {

    constructor() {
        super();
        this.state = {
            data: {
                count: 0,
                next: "",
                previous: "",
                results: []
            },
            loading: true,
            page: 1,
            search: "",
            header: ['Nº', 'Total', 'Comanda']
        };

        this.initialFetch = this.initialFetch.bind(this);
        this.updateTable = this.updateTable.bind(this);
        this.goSale = this.goSale.bind(this);
        this.main_toolbar = React.createRef()
    }

    componentDidMount() {
        this.initialFetch("", 1);
    };

    goSale = (sale) => {
        localDB.saveSaleStorage(sale, 'sale');
        this.props.history.push(`/sale/view/${sale.billing_number}`);
    };

    addSale = () => {
        let data = {
            order: {
                quantity: 1,
                waiter: null,
                type: 4,
                client: null,
                state: 1
            },
        };
        SaleData.open(data, (res) => {
            if (res !== null && res.hasOwnProperty('id')) {
                SaleData.get(res.id, (res) =>{
                    if(res.hasOwnProperty('id')){
                        this.goSale(res);
                    }
                    else {
                        this.props.showToast({message: 'Tenemos un problema, inténtalo más tarde!', type: 'error'});
                    }
                });
            } else {
                this.props.showToast({message: 'Tenemos un problema, inténtalo más tarde!', type: 'error'});
            }
            this.setState({sending: false});
            this.main_toolbar.current.handleAdding()
        });
    };

    async initialFetch(search, page) {
        let data = await SaleData.counterSaleList(search, page);
        if (this.state.page === 1) {
            this.setState({data, loading: false});
        } else {
            let oldData = this.state.data.results.slice();
            let newData = update(this.state, {
                data: {
                    results: {
                        $set: oldData.concat(data.results)
                    },
                    next: {
                        $set: data.next
                    }
                }
            });
            this.setState(newData);
        }
    };

    handleSearch = (search) => {
        this.initialFetch(search, 1)
    };

    loadMore = () => {
        let page = this.state.page + 1;
        let search = this.state.search;
        this.setState({page: page, search: search});
        this.initialFetch(search, page);
    };

    updateTable(res, index) {
        let oldData = this.state.data.results.slice();
        oldData[index] = res;
        let data = update(this.state, {
            data: {
                results: {
                    $set: oldData
                }
            }
        });
        this.setState(data);
    };

    render() {
        let rows = this.state.data.results.length > 0 ? this.state.data.results.map(function (delivery, index) {
            return (
                <Table.Row key={delivery.id}>
                    <Table.Cell>
                        {("0000000" + delivery.billing_number).slice(-4)}
                    </Table.Cell>
                    <Table.Cell>
                        <Header as='h3' textAlign='center' style={{margin:'0px'}}>
                            Total Venta: $<FormattedNumber
                            value={delivery.total.total_sale}
                            currency="USD"
                            maximumFractionDigits={0}
                            minimumFractionDigits={0}
                        />
                        </Header>
                        {
                            delivery.total.balance !== 0 ? <Header as='h3' textAlign='center' style={{margin:'0px'}} color='orange'>
                                Saldo: $<FormattedNumber
                                value={delivery.total.balance}
                                currency="USD"
                                maximumFractionDigits={0}
                                minimumFractionDigits={0}
                            />
                            </Header>:null
                        }
                    </Table.Cell>
                    <Table.Cell>
                        <List divided relaxed>
                            { delivery.items.length >0 ?
                                delivery.items.map(function (item) {
                                    return (
                                        <List.Item key={item.id}>
                                            <Image avatar>
                                                <Label circular color='orange'>{item.quantity}</Label>
                                            </Image>
                                            <List.Content>
                                                <List.Header as='h3'>{item.product.name}</List.Header>
                                                <List.Description>{item.observation}</List.Description>
                                            </List.Content>
                                        </List.Item>
                                    )
                                }):<List.Item>
                                    <List.Content>
                                        <List.Description>
                                            <Label style={{width:'100%'}}>
                                                <Icon name='alarm' /> No se han agregado productos
                                            </Label>
                                        </List.Description>
                                    </List.Content>
                                </List.Item>
                            }
                            <List.Item key={1}>
                                <Button content='Ver Pedido' fluid primary icon='food'
                                        labelPosition='left'
                                        onClick={() => this.goSale(delivery)}/>
                            </List.Item>
                        </List>
                    </Table.Cell>
                </Table.Row>
            )
        }, this) : <NoData colSpan={7}/>;


        let loadMore = <Table.Row>
            <Table.Cell colSpan={7}>
                <Button fluid onClick={() => this.loadMore()}>Cargar Más</Button>
            </Table.Cell>
        </Table.Row>;

        let header = this.state.header.map(function (header, i) {
            return (
                <Table.HeaderCell key={i}>
                    {header}
                </Table.HeaderCell>
            )
        }, this);

        let table = <Table celled striped>
            <Table.Header>
                <Table.Row>
                    <Table.HeaderCell colSpan='7'>
                        <MainToolbar
                            title="En Mostrador"
                            name="Pedido"
                            icon="food"
                            ref={this.main_toolbar}
                            disable_button_add={true}
                            btnAdd={true}
                            callbackAdd={this.addSale}
                            callbackSearch={this.handleSearch}
                        />
                    </Table.HeaderCell>
                </Table.Row>
            </Table.Header>
            <Table.Header>
                <Table.Row>
                    {header}
                </Table.Row>
            </Table.Header>
            <Table.Body>
                {this.state.loading ? <LoadingRow colSpan={5}/>: rows}
                {this.state.data.next ? loadMore : null}
            </Table.Body>
        </Table>;


        return (
            <div>
                {table}
            </div>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return {
        showToast(data){
            dispatch(showToast(data))
        },
    }
}

export default connect(
    null,
    mapDispatchToProps
)(withRouter(CounterSale));


// WEBPACK FOOTER //
// ./src/containers/sale/CounterSale.js